const isIPv4 = (host) => {
  const parts = host.split('.');
  if (parts.length !== 4) return false;
  return parts.every((p) => {
    if (!/^\d{1,3}$/.test(p)) return false;
    const n = Number(p);
    return n >= 0 && n <= 255;
  });
};

const isIPv6 = (host) => host.includes(':');

export const monthYearWith2Digit = (number) => {
  if (!number) return "";
  if (number > 999) return number.toString().substring(2, 4);
  return number.toString().padStart(2, '0');
}

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const numberWithK = (x) => {
  return x > 999 ? (x / 1000).toFixed(1) + 'k' : x?.toFixed(2);
}

export const isValidEmail = (email) => {
  const str = String(email || '').trim();
  if (!str || /\s/.test(str)) return false;
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(str);
}

export const isValidUrl = (url) => {
  const str = String(url || '').trim();
  if (!str || /\s/.test(str)) return false;

  const hasProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(str);
  const candidate = hasProtocol ? str : `http://${str}`;

  try {
    const u = new URL(candidate);
    if (!['http:', 'https:'].includes(u.protocol)) return false;
    const host = u.hostname;
    if (!host) return false;
    if (host === 'localhost' || isIPv4(host) || isIPv6(host)) return true;

    if (!host.includes('.')) return false;
    const labels = host.split('.');
    if (labels.some((l) => !/^[a-zA-Z0-9-]+$/.test(l) || l.startsWith('-') || l.endsWith('-') || l.length === 0 || l.length > 63)) {
      return false;
    }
    const tld = labels[labels.length - 1];
    if (!/^[a-zA-Z]{2,}$/.test(tld)) return false;
    return true;
  } catch (_) {
    return false;
  }
};

export const isValidUrls = (urls) => {
  if (!urls || urls.length < 1) return false;
  const urlList = urls.split('\n');
  if (urlList.some((url) => !isValidUrl(url))) return false;
  return true;
};

export const isSitemapUrl = (url) => {
  if (!isValidUrl(url)) return false;
  if (!url.endsWith('.xml')) return false;
  return true;
};

// Project name must be text and numbers
export const isValidProjectName = (name) => {
  if (!name || name.length < 1) return false;
  if (!/^[a-zA-Z0-9- ]+$/.test(name)) return false;
  if (name.startsWith('-') || name.endsWith('-')) return false;
  return true;
};

export const getProjectDomain = (sitemap) => {
  var sitemapxml = sitemap ? sitemap : "";
  if (!sitemapxml.includes("http://") && !sitemapxml.includes("https://")) {
    sitemapxml = `https://${sitemapxml}`;
  }
  const domainList = sitemapxml?.match(/https?:\/\/([^/]+)/);
  const domain = domainList ? domainList[1] : "";
  return domain;
}

export const getProjectOriginalSubUrl = (original) => {
  const url = original?.includes("://") ? original : `https://${original}`;
  const subUrl = url.split("://")[1];
  return subUrl.replace(subUrl.split("/")[0], "");
}
